<template>
  <table class="table pb-16">
    <tbody>
      <tr v-for="(invoice, index) in unpaidData.invoices" :key="index">
        <td>
          {{ invoice.line_items[0].description }}<br />
          {{ moment.unix(invoice.line_items[0].date_from).format('ll') }}
          -
          {{ moment.unix(invoice.line_items[0].date_to).format('ll') }}
          <ui-tooltip-icon
            preset="help"
            :text="
              t('The date of subscription change and date, when the current billing period ends.')
            "
          ></ui-tooltip-icon>
        </td>
        <td class="text-center">${{ sumFormat(invoice.amount_due) }}</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td><b>{{ t('Total') }}</b></td>
        <td>
          <b>${{ totalUnpaid }}</b>
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script setup lang="ts">
import moment from 'moment-timezone';
import { useI18n } from '@/composables';

defineProps<{
  unpaidData: {
    invoices: {
      amount_due: number;
      line_items: {
        description: string;
        date_from: number;
        date_to: number;
      }[];
    }[];
  };
  totalUnpaid: string | number;
  sumFormat: (value: number) => string;
}>();

const { t } = useI18n();
</script>

<style lang="scss" scoped>
.table {
  width: 100%;
  background: none;
  border: none;

  td {
    border-right: none;
    padding-left: 0;
    font-size: 15px;
    line-height: normal;

    &:last-child {
      text-align: right;
      padding-right: 0;
    }
  }

  tr {
    border: none !important;
    border-bottom: 1px solid var(--color-gray10) !important;
  }

  tfoot {
    tr {
      font-size: 15px;
      font-weight: bold;

      td:first-child {
        padding-left: 0 !important;
      }

      td:last-child {
        padding-right: 0 !important;
      }

      border: none;
      border-bottom: 2px solid var(--color-gray10);
    }
  }
}
</style>
